module.exports = __webpack_public_path__ + "static/img/15bac.9a07949.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/15bac.jpg
// module id = rIDr
// module chunks = 1